export default __webpack_public_path__ + "static/sc-prit-e54612b1f43b8915de7ffcedb3cb8df7.webp";